import { ConsultarHistoricoComponent } from './consultar-historicos.component';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { ConsultarHistoricoRouting } from './consultar-historico-routing.module';

  
  @NgModule({
    declarations: [ConsultarHistoricoComponent],
    imports: [
      ConsultarHistoricoRouting,
      SharedModule,
      CommonModule,
    ],
    entryComponents: []
  })

  export class consultaHistoricoModule{}